import { Navigate } from "react-router-dom"
import { AppShell } from "components/dashboard/app-shell"
import TeamPageNew from "./TeamPageNew"
import { useUser } from "contexts/UserContext"

export default function TeamPageWrapper() {
  const { user, loading } = useUser()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: `linear-gradient(to bottom right, var(--hexa-bg-gradient-start), var(--hexa-bg-gradient-mid), var(--hexa-bg-gradient-end))` }}>
        <div className="text-[var(--hexa-text-primary)] text-lg">Caricamento...</div>
      </div>
    )
  }

  if (!user && !localStorage.getItem('accessToken')) {
    return <Navigate to="/login" replace />
  }

  return (
    <AppShell currentUser={user}>
      <TeamPageNew />
    </AppShell>
  )
}
